/**
 * MIT License
 * Copyright (c) 2023 Jamasp Team
 */
export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid var(--jp-gray-200, #D6E2EB)',
      marginTop: 'auto',
      padding: '20px 32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 12,
      fontFamily: "'DM Sans', sans-serif",
      fontSize: 13,
      color: '#94A6B8',
    }}>
      <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
        <a href="/about"   style={linkStyle}>About</a>
        <a href="/privacy" style={linkStyle}>Privacy</a>
        <a href="/terms"   style={linkStyle}>Terms</a>
      </div>

      <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12 }}>
        © {new Date().getFullYear()}{' '}
        <a href="https://jamasp.app/" style={{ ...linkStyle, color: '#0A66C2' }}>Jamasp</a>
      </span>

      <a href="mailto:support@cut.social" style={linkStyle}>Contact</a>
    </footer>
  );
}

const linkStyle = {
  color: '#94A6B8',
  textDecoration: 'none',
  transition: 'color 100ms',
};
